
    let currentIndex = 0; // Initialize the current index of the displayed review
    const reviewsPerPage = 4; // Number of reviews displayed at once
    const reviewCards = document.querySelectorAll('.review-card');
    const totalReviews = reviewCards.length;

    // Function to move the carousel
    function moveCarousel(direction) {
        // Hide all reviews
        for (let i = 0; i < totalReviews; i++) {
            reviewCards[i].style.display = 'none';
        }

        // Calculate the new index based on the direction
        currentIndex += direction * reviewsPerPage;

        // Handle continuous scrolling
        if (currentIndex < 0) {
            currentIndex = totalReviews - (totalReviews % reviewsPerPage || reviewsPerPage);
        } else if (currentIndex >= totalReviews) {
            currentIndex = 0;
        }

        // Display the new set of reviews
        for (let i = currentIndex; i < currentIndex + reviewsPerPage; i++) {
            const adjustedIndex = i % totalReviews; // Handle wrapping
            reviewCards[adjustedIndex].style.display = 'block';
        }
    }

    // Initial display of reviews
    for (let i = currentIndex; i < currentIndex + reviewsPerPage; i++) {
        const adjustedIndex = i % totalReviews; // Handle wrapping
        reviewCards[adjustedIndex].style.display = 'block';
    }

 function adjustLayout() {
        if ($(window).width() <= 767) {
            // Hide the navigation buttons
            $('.prev-btn, .next-btn').hide();
            $('.review-carousel-container').css('justify-content', 'initial');

            // Display all review cards without spacing
         
        } else {
            // Show the navigation buttons
            $('.prev-btn, .next-btn').show();
                        $('.review-carousel-container').css('justify-content', 'center');

            // Reset the layout for desktop view
         
        }
    }

    // Adjust the layout on page load and when the window is resized
    $(document).ready(adjustLayout);
    $(window).resize(adjustLayout);